export default function hiddenCellService() {
  return function generate(viewField, engineApi, engineGridApi) {
    return engineApi.cell.setCommonAttributes(viewField, engineApi, engineGridApi);
  };
}
